import { useAppSelector } from 'store/hook';
import { WeatherDisplay } from './Weather';

/*
  This component is used to display the current weather in the top bar.
*/
export const WeatherComponent = () => {
  const { data, isLoading } = useAppSelector((state) => state.weatherReducer);

  return <>{isLoading ? <></> : <WeatherDisplay data={data} />}</>;
};
